import React from 'react'

const Manual_venta_giftcards_automatica = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Venta de Gift Cards por tarea automática
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Configura la venta automatizada de gift cards dentro de Clau.io para simplificar tus procesos.
        </p>
        <iframe
          src="https://scribehow.com/embed/Venta_de_Gift_Cards_por_tarea_automatica__gUrsP4GnQzGqkvePUGeHmw?as=scrollable"
          className="scribe-iframe-general-126"
          width="100%"
          height="11700"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_venta_giftcards_automatica
